// appsBrowser JS, for content block in new theme 
// datarobot6/views/gutenberg/content/dr-apps-browser.twig

document.addEventListener('DOMContentLoaded', function() {
    // Helper function to toggle tabs
    const toggleTabs = (tabs, panels, activeTabClass, activePanelClass) => {
        tabs.forEach((tab, index) => {
            tab.addEventListener('click', () => {
                // Remove active class from all tabs and hide all panels
                tabs.forEach(t => t.classList.remove(activeTabClass));
                if (panels) panels.forEach(p => p.classList.remove(activePanelClass));

                // Add active class to the clicked tab and show the corresponding panel
                tab.classList.add(activeTabClass);
                if (panels) panels[index].classList.add(activePanelClass);
            });
        });

        // Open the first tab and panel by default
        if (tabs.length > 0) {
            tabs[0].classList.add(activeTabClass);
            if (panels) panels[0].classList.add(activePanelClass);
        }
    };

    // Handle mobile accordion (js-accordionWrapper)
    const accordionWrapper = document.querySelector('.js-accordionWrapper');
    if (accordionWrapper) {
        const accordionTabs = accordionWrapper.querySelectorAll('.accordionTabToggle');
        toggleTabs(accordionTabs, null, '-tabOpen', null);
    }

    // Handle desktop accordion (js-accordionPanelWrapper)
    const desktopWrapper = document.querySelector('.js-accordionPanelWrapper');
    if (desktopWrapper) {
        const desktopTabs = desktopWrapper.querySelectorAll('.accordionPanelToggle');
        const desktopSlides = desktopWrapper.querySelectorAll('.accordionPanel__slide');
        toggleTabs(desktopTabs, desktopSlides, '-tabOpen', '-panelVisible');
    }

    // console.log("accordion load test");
});
